import axiosPost from "./axiosPost";

export const paisGet = async (credentials) => {
    const body = {
        service: "MIAPaisGet",
        params: {
            paisConBandera: "N",
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
